export default __webpack_public_path__ + "static/media/head.6e36d41a.jpg";